import { IDateData } from '../inputDateReducer';
import isDayValueValid from './isDayValueValid';
import isMonthValueValid from './isMonthValueValid';

export default function visitedResolver(
	state: IDateData,
	lastDayOfTheMonth: number,
) {
	const valueAddAttempted =
		state.day.valueAddAttempted &&
		state.month.valueAddAttempted &&
		state.year.valueAddAttempted;

	const allVisited =
		state.day.visited && state.month.visited && state.year.visited;

	if ((state.day.visited && valueAddAttempted) || allVisited) {
		const dayValid = isDayValueValid(state.day.value, lastDayOfTheMonth);
		state.day.error = !dayValid;
		state.day.valid = dayValid;
	}

	if ((state.month.visited && valueAddAttempted) || allVisited) {
		const monthValid = isMonthValueValid(state.month.value);
		state.month.error = !monthValid;
		state.month.valid = monthValid;
	}

	if ((state.year.visited && valueAddAttempted) || allVisited) {
		state.year.error = !state.year.value;
		state.year.valid = !state.year.error;
	}
}
